export const WORKFLOW_STEPS = [
    { no: 1, code: 'REORDER_DECISION', zh: '加单判断', ko: '추가발주 판단', inScope: false },
    { no: 2, code: 'STYLE_NO_PROCESS', zh: '款号处理', ko: '스타일번호 처리', inScope: false },
    { no: 3, code: 'MASTER_DATA_CHECK', zh: '主数据检查', ko: '마스터데이터 확인', inScope: false },
    { no: 4, code: 'REORDER_PLAN_INPUT', zh: '输入加单企划信息', ko: '추가발주 기획정보 입력', inScope: false },
    { no: 5, code: 'SHEET_CREATE', zh: '委托书创建', ko: '의뢰서 생성', inScope: true },
    { no: 6, code: 'SHEET_APPROVE', zh: '委托书审批', ko: '의뢰서 승인', inScope: true },
    { no: 7, code: 'FABRIC_WIDTH_INPUT', zh: '面料幅宽输入', ko: '원단 폭 입력', inScope: true },
    {
        no: 8,
        code: 'TRIM_ATTR_INPUT',
        zh: '辅料颜色/附加信息输入',
        ko: '부자재 색상·부가정보 입력',
        inScope: true,
    },
    { no: 9, code: 'BASE_SIZE_INPUT', zh: '基准尺寸输入', ko: '기준치수 입력', inScope: true },
    { no: 10, code: 'MATERIAL_USAGE_INPUT', zh: '原材料用量输入', ko: '원자재 소요량 입력', inScope: true },
    { no: 11, code: 'TRIM_USAGE_INPUT', zh: '辅材料用量输入', ko: '부자재 소요량 입력', inScope: true },
    { no: 12, code: 'SIZE_TOLERANCE_INPUT', zh: '尺寸偏差输入', ko: '치수 편차 입력', inScope: true },
    { no: 13, code: 'SAP_TRANSFER', zh: 'SAP 数据传送', ko: 'SAP 데이터 전송', inScope: true },
    { no: 14, code: 'DEMAND_MANAGE', zh: '需求量管理', ko: '소요량 관리', inScope: false },
    { no: 15, code: 'PO_APPROVE', zh: '审批采购订单', ko: '구매오더 승인', inScope: false },
    { no: 16, code: 'PRICE_DECISION', zh: '决定售价（含 Listing）', ko: '판매가 결정(Listing 포함)', inScope: false },
    {
        no: 17,
        code: 'MATERIAL_GR',
        zh: '面辅料/外包加工入库和确定',
        ko: '원부자재·외주가공 입고 및 확정',
        inScope: false,
    },
    { no: 18, code: 'INVOICE_VERIFY', zh: '采购发票校验', ko: '구매 송장 검증', inScope: false },
    { no: 19, code: 'PRODUCTION_GR', zh: '生产入库', ko: '생산 입고', inScope: false },
];
export const IN_SCOPE_STEPS = WORKFLOW_STEPS.filter((s) => s.inScope);
export function getWorkflowStep(no) {
    return WORKFLOW_STEPS.find((s) => s.no === no);
}
/**
 * 委托书单据状态。
 *
 * 说明：这是按“第 5 步创建 → 第 6 步审批”这一通用单据流转推导的最小状态集，
 * 用于把架构先跑通。第 5 步详细需求确认后需要重新核对（是否有多级审批、
 * 是否有作废/退回重提、是否有版本修订等）。
 */
export const SHEET_STATUS = {
    /** 草稿：创建中，尚未提交审批 */
    DRAFT: 'DRAFT',
    /** 审批中：已提交，等待审批 */
    PENDING: 'PENDING',
    /** 已批准 */
    APPROVED: 'APPROVED',
    /** 已驳回 */
    REJECTED: 'REJECTED',
    /** 已作废 */
    CANCELLED: 'CANCELLED',
};
export const SHEET_STATUS_LABELS = {
    [SHEET_STATUS.DRAFT]: { zh: '草稿', ko: '임시저장' },
    [SHEET_STATUS.PENDING]: { zh: '审批中', ko: '승인 대기' },
    [SHEET_STATUS.APPROVED]: { zh: '已批准', ko: '승인 완료' },
    [SHEET_STATUS.REJECTED]: { zh: '已驳回', ko: '반려' },
    [SHEET_STATUS.CANCELLED]: { zh: '已作废', ko: '폐기' },
};
//# sourceMappingURL=workflow.js.map